<template >
<div class="page-content-wrapper">
    <div class="card rounded-3 border-1 shadow">
        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
            <h2 class="text-s fw-bold">Assets</h2>
        </div>

        <div class="card-body">
            <CustomTable
                :columns="columns"
                :fetchData="fetch_assets"
                :key="fetch_assets"
                :hasActions="true"
            >
                <template v-slot:cell-asset_type="{ row }">
                    <span class="text-xs">{{ row.asset_type || 'N/A' }}</span>
                </template>
                
                <template v-slot:cell-company_name="{ row }">
                    <span class="text-xs">{{ row.company_name || 'N/A' }}</span>
                </template>
                
                <template v-slot:cell-workflow_name="{ row }">
                    <span :class="['text-xs', row.workflow_name === 'Not Assigned' ? 'text-muted' : 'text-primary']">
                        {{ row.workflow_name }}
                    </span>
                </template>
                
                <template v-slot:cell-date_created="{ row }">
                    <span class="text-xs">{{ formatDate(row.date_created) }}</span>
                </template>
                <template v-slot:cell-asset_status="{ row }">
                    <div class="form-check form-switch">
                        <label 
                            :class="['form-check-label text-xs', row.is_active ? 'text-success' : 'text-secondary']"
                            :for="'status-switch-' + row.id"
                        >
                            {{ row.is_active ? "Active" : "Inactive" }}
                        </label>
                    </div>
                </template>
                
                <template v-slot:actions="{ row }">
                    <span v-if="row">
                        <button
                            class="btn btn-dark btn-sm text-xxs fw-bold rounded-3 me-3"
                            @click="view_asset(row.id)"
                            title="View Asset Details"
                        >
                           View
                        </button>
                    </span>
                </template>
            </CustomTable>
        </div>
    </div>
</div>
</template>
<script src="./view_assets.js"></script>